/**
 * Session-expired banner (doc 147 §8.2 AUTH-03).
 *
 * Long-running tabs that hit a token-revocation event fail silently otherwise;
 * this non-blocking banner offers a re-auth CTA without losing view state.
 */
import { Icon } from '../components/Icon.js';

export interface SessionExpiredBannerProps {
  onReauth: () => void;
}

export function SessionExpiredBanner({
  onReauth,
}: SessionExpiredBannerProps): React.JSX.Element {
  return (
    <div className="banner" role="alert">
      <Icon name="warning" size="sm" />
      <span>Your session expired.</span>
      <button
        className="btn"
        style={{ marginLeft: 'auto', color: 'var(--s0)', textDecoration: 'underline' }}
        onClick={onReauth}
      >
        Sign in again
      </button>
    </div>
  );
}
